import classes from "../show-traditions/filter-modal/filter-modal.module.css";
import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { useDispatch } from "react-redux";
import {
  setSelectedNode,
  toggleTreeIsOpen,
} from "../../features/summaryTree/summaryTreeSlice";

import "react-checkbox-tree/lib/react-checkbox-tree.css";
import Input from "../ui/input";
import { extractTreeIndex, get4LevelsData } from "../../utils/manipulation";
import { BiFileBlank } from "react-icons/bi";
import { Tooltip } from "@mui/material";
import { MdOutlineFileCopy } from "react-icons/md";

const getBGColor = (level) => (level === 1 ? "#eefff850" : "rgb(235 255 235)");
// const getBGColor = (level) => (level === 1 ? "#eefff850" : "#eefff8");

function ChevronNLayer({
  noOfLayers = 1,
  direction = "right",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  gap = 5,
  style,
}) {
  const rotations = { down: 0, right: 90, up: 180, left: -90 };
  const rotate = rotations[direction] ?? 0;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform: `rotate(${rotate}deg)`,
        transition: "all 0.2s linear",
        ...style,
      }}
    >
      <polyline
        points="6,8 12,14 18,8"
        stroke={color}
        strokeWidth={strokeWidth}
        transform={`translate(0, -${gap})`}
      />
      {noOfLayers > 1 && (
        <polyline
          points="6,10 12,16 18,10"
          stroke={color}
          strokeWidth={strokeWidth}
        />
      )}
      {noOfLayers > 2 && (
        <polyline
          points="6,12 12,18 18,12"
          stroke={color}
          strokeWidth={strokeWidth}
          transform={`translate(0, ${gap})`}
        />
      )}
    </svg>
  );
}

export const TreeItem = ({
  children,
  level,
  label,
  className,
  onClick,
  open,
  flag,
  selected,
}) => {
  const hasChildren = children?.props?.children?.length > 0;

  const [showChildren, setShowChildren] = useState(open);
  const ref = useRef();
  const [bgColor, setBgColor] = useState(null);

  useEffect(() => {
    setShowChildren(open);
  }, [flag]);

  const iconStyle = {
    width: "22px",
    height: "22px",
    marginTop: "4px",
    display: "block",
  };

  return (
    <li
      className={` ${!hasChildren && "hover:bg-[#deffe8]"} cursor-pointer`}
      onClick={(e) => {
        e.stopPropagation();
        if (hasChildren && !ref.current?.contains(e.target))
          setShowChildren(!showChildren);
        if (onClick) onClick(e);
      }}
      onMouseEnter={() => setBgColor("#deffe8")}
      onMouseLeave={() => setBgColor(null)}
      style={{
        paddingRight: level === 4 ? "9%" : "7%",
        color: !hasChildren
          ? "#006600"
          : level === 2
            ? "var(--primary-color)"
            : showChildren && "black",
        backgroundColor: selected
          ? "#beffc8"
          : !showChildren
            ? bgColor
            : hasChildren && showChildren && getBGColor(level),
        cursor: !hasChildren && "pointer",
        fontSize: level === 2 ? 15 : !hasChildren && 13,
        borderBottom: level === 2 && "1px solid #ddd",
        paddingBottom: level === 2 && 8,
        paddingTop: level === 2 && 8,
      }}
    >
      <div
        className={`flex justify-start ${
          hasChildren ? "items-start" : "items-start"
        }`}
      >
        {hasChildren && (
          <div
            style={{
              width: "20px",
              height: "20px",
              transform:
                showChildren && level === 1
                  ? "translateY(8px)"
                  : "translateY(4px)",
            }}
          >
            <ChevronNLayer
              style={{
                width: "16px",
                height: "16px",
              }}
              noOfLayers={level}
              direction={showChildren ? "down" : "right"}
            />
          </div>
        )}
        {!hasChildren && (
          <div
            style={{
              width: "22px",
              height: "22px",
              display: "block",
            }}
          >
            {level !== 4 ? (
              <BiFileBlank style={iconStyle} />
            ) : (
              <MdOutlineFileCopy style={iconStyle} />
            )}
          </div>
        )}
        <span
          className={`${className} inline sm:hidden`}
          style={{
            marginRight: level === 1 ? 0 : level + 1 + "px",
          }}
        >
          {label}
        </span>
        <Tooltip
          enterDelay={1250}
          enterNextDelay={1250}
          leaveDelay={0}
          placement="left-end"
          title={
            <div
              dir="rtl"
              className="text-2xl px-4 py-1 text-right font-[IRANSansWeb]"
              style={{ lineHeight: 2 }}
            >
              {label}
            </div>
          }
        >
          <span
            className={`truncate ${className} hidden sm:inline`}
            style={{
              marginRight: level === 1 ? 0 : level + 1 + "px",
            }}
          >
            {label}
          </span>
        </Tooltip>
      </div>
      {showChildren && (
        <div
          ref={ref}
          style={{
            // transition: `max-height 4s linear`,
            display: showChildren ? "block" : "none",
            // width: showChildren ? "100%" : "0%",
            // maxHeight: showChildren ? "8000px" : 0,
            overflow: "hidden",
          }}
        >
          {children}
        </div>
      )}
    </li>
  );
};

const getIthLevelIndexPortion = (i, index) =>
  index >= 0 ? index + `l${i}` : "";

const getIthLevelIndex = (i1, i2, i3, i4) => {
  return (
    getIthLevelIndexPortion(1, i1) +
    getIthLevelIndexPortion(2, i2) +
    getIthLevelIndexPortion(3, i3) +
    getIthLevelIndexPortion(4, i4)
  );
};

const imamsOrder = [
  "پیامبر",
  "حضرت فاطمه",
  "امیرالمؤمنین",
  "امام حسن",
  "امام حسین",
  "امام سجّاد",
  "امام محمّد",
  "امام جعفر",
  "امام موسی",
  "امام رضا",
  "امام جواد",
  "امام هادی",
  "امام عسکری",
  "امام زمان",
];

const MySummaryTree = ({ data, section, selectedNode }) => {
  const dispatch = useDispatch();
  const [filterText, setFilterText] = useState("");
  const [filteredNodes, setFilteredNodes] = useState([]);
  const [treeStructuredData, setTreeStructuredData] = useState([]);
  useEffect(() => {
    const data4Levels = get4LevelsData(data);

    let newc = data4Levels.map((level1, i1) => {
      const levelIndex = getIthLevelIndex(i1);
      return {
        value: levelIndex + level1.alphabet,
        label: level1.alphabet,
        children: level1.subjects?.map((level2, i2) => {
          const levelIndex = getIthLevelIndex(i1, i2);
          return {
            value: levelIndex + level2.title,
            label: level2.title,
            children: level2.sub_subjects?.map((level3, i3) => {
              const levelIndex = getIthLevelIndex(i1, i2, i3);
              return {
                value: levelIndex + level3.title,
                label: level3.title,
                children: level3.subjects_3?.map((level4, i4) => {
                  const levelIndex = getIthLevelIndex(i1, i2, i3, i4);
                  return {
                    value: levelIndex + level4.title,
                    label: level4.title,
                    children: [],
                  };
                }),
              };
            }),
          };
        }),
      };
    });
    setTreeStructuredData(newc);
  }, [data]);

  useEffect(() => {
    if (treeStructuredData?.length > 0 && !selectedNode[section]) {
      const level3 = treeStructuredData[0]?.children[0]?.children[0];
      const level4 = level3?.children?.[0];

      const item = level4?.value ?? level3?.value;

      if (item)
        dispatch(
          setSelectedNode({
            node: {
              ...selectedNode,
              [section]: item,
            },
          })
        );
    }
  }, [treeStructuredData, selectedNode, dispatch, section]);

  const filterNodes = useCallback(
    (filtered, node) => {
      const children = (node.children || []).reduce(filterNodes, []);

      if (
        node.label.toLocaleLowerCase().indexOf(filterText.toLocaleLowerCase()) >
        -1
      ) {
        filtered.push(node);
      } else if (children.length) filtered.push({ ...node, children });

      return filtered;
    },
    [filterText]
  );

  useEffect(() => {
    if (!filterText) {
      setFilteredNodes(treeStructuredData);
      return;
    }
    setFilteredNodes(treeStructuredData.reduce(filterNodes, []));
  }, [filterText, treeStructuredData, filterNodes]);

  const onClick = (value, hasSubItem) => {
    if (!hasSubItem) {
      dispatch(toggleTreeIsOpen());
      dispatch(
        setSelectedNode({ node: { ...selectedNode, [section]: value.value } })
      );
    }
  };

  const [flag, setFlag] = useState(false);

  useEffect(() => {
    setFlag((pre) => !pre);
  }, [setFlag]);

  const isOpen = (value) => {
    if (!value || !selectedNode[section]) return false;
    const valueTreeIndex = extractTreeIndex(value);
    const [lvl1, lvl2, lvl3, lvl4] = valueTreeIndex;

    const selectedNodeValue = selectedNode[section];
    const nodeTreeIndex = extractTreeIndex(selectedNodeValue);
    const [lvl1Node, lvl2Node, lvl3Node, lvl4Node] = nodeTreeIndex;

    if (
      lvl1 === lvl1Node &&
      lvl2 === undefined &&
      lvl3 === undefined &&
      lvl4 === undefined
    )
      return true;
    if (
      lvl1 === lvl1Node &&
      lvl2 === lvl2Node &&
      lvl3 === undefined &&
      lvl4 === undefined
    )
      return true;
    if (
      lvl1 === lvl1Node &&
      lvl2 === lvl2Node &&
      lvl3 === lvl3Node &&
      lvl4 === undefined
    )
      return true;

    if (
      lvl1 === lvl1Node &&
      lvl2 === lvl2Node &&
      lvl3 === lvl3Node &&
      lvl4 === lvl4Node
    )
      return true;
    return false;
  };

  const sortedData = useMemo(() => {
    return filteredNodes?.map((lvl1) => {
      const sortedLevel2 = [...(lvl1?.children ?? [])];

      if (lvl1?.label === "ائمه اطهار علیهم السلام") {
        sortedLevel2?.sort(
          (a, b) =>
            imamsOrder?.findIndex((name) => a?.label?.includes(name)) -
            imamsOrder?.findIndex((name) => b?.label?.includes(name))
        );
      }

      return {
        ...lvl1,
        children: sortedLevel2?.map((lvl2) => {
          const sortedLevel3 = [...(lvl2?.children ?? [])];
          sortedLevel3?.sort(
            (a, b) => b?.children?.length - a?.children?.length
          );

          return { ...lvl2, children: sortedLevel3 };
        }),
      };
    });
  }, [filteredNodes]);

  return (
    <div className={classes.alphabet} style={{ paddingBottom: "40px" }}>
      <p style={{ fontSize: 18 }}>فهرست موضوعات</p>
      <Input
        className="w-full my-2"
        style={{ height: "48px" }}
        type="search"
        placeholder="جستجو در فهرست"
        value={filterText}
        onChange={(e) => setFilterText(e.target.value)}
      />

      <ul>
        {sortedData?.map((node) => {
          return (
            <TreeItem
              label={node.label}
              level={1}
              open={isOpen(node.value)}
              flag={flag}
            >
              <ul>
                {node.children?.map((child) => {
                  return (
                    <TreeItem
                      label={child.label}
                      level={2}
                      open={isOpen(child.value)}
                      flag={flag}
                    >
                      <ul>
                        {child?.children?.map((item) => {
                          const hasSubItem = item?.children?.length > 0;
                          const open = isOpen(item.value);
                          return (
                            <TreeItem
                              label={item.label}
                              level={3}
                              onClick={() => {
                                onClick(item, hasSubItem);
                              }}
                              open={open}
                              flag={flag}
                              selected={
                                selectedNode[section] === item.value &&
                                !hasSubItem
                              }
                            >
                              <ul>
                                {item?.children?.map((subItem) => {
                                  return (
                                    <TreeItem
                                      label={subItem.label}
                                      level={4}
                                      onClick={() => {
                                        onClick(subItem);
                                      }}
                                      open={open && isOpen(subItem.value)}
                                      flag={flag}
                                      selected={
                                        selectedNode[section] === subItem.value
                                      }
                                    />
                                  );
                                })}
                              </ul>
                            </TreeItem>
                          );
                        })}
                      </ul>
                    </TreeItem>
                  );
                })}
              </ul>
            </TreeItem>
          );
        })}
      </ul>
    </div>
  );
};

export default React.memo(MySummaryTree);
